(function (window, document) {
  'use strict';

  function init() {
    var root = document.querySelector('[data-adp-archie-five]');
    if (!root || root.dataset.describeScrollReady === 'true') return;

    var hero = root.querySelector('[data-adp-archie-five-hero]');
    var panel = root.querySelector('[data-adp-archie-describe-panel]');
    if (!hero || !panel) return;

    root.dataset.describeScrollReady = 'true';

    var threshold = Number(hero.getAttribute('data-describe-reveal-threshold'));
    if (!Number.isFinite(threshold)) threshold = 0.20;
    threshold = Math.min(0.8, Math.max(0, threshold));

    var frame = 0;
    var revealed = null;

    function setRevealed(nextState) {
      if (revealed === nextState) return;
      revealed = nextState;

      root.classList.toggle('is-describe-revealed', nextState);
      panel.setAttribute('aria-hidden', String(!nextState));
      panel.inert = !nextState;

      if (!nextState && panel.contains(document.activeElement)) {
        document.activeElement.blur();
      }
    }

    function update() {
      frame = 0;

      var rect = hero.getBoundingClientRect();
      var height = Math.max(rect.height, 1);
      var scrolledOut = Math.min(1, Math.max(0, -rect.top / height));

      root.style.setProperty('--archie5-describe-scroll', scrolledOut.toFixed(3));
      setRevealed(scrolledOut >= threshold);
    }

    function schedule() {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(window, document);
